import { VStack } from '@components/Customized';
import { CapaPurchaseOrderStatus } from '@generated/graphql';
import { ProgressInfoReason } from '../ProgressInfoReason';
import Paid from './Paid';
import { ProgressInfoBottomItemCommonProps } from './types';

interface ProgressStoppedProps extends ProgressInfoBottomItemCommonProps {
  cancelReason?: string;
}

const orderStatusToTitle = (status?: CapaPurchaseOrderStatus) => {
  switch (status) {
    case CapaPurchaseOrderStatus.CancelRequested:
      return '취소사유';
    case CapaPurchaseOrderStatus.RefundRequested:
      return '환불사유';
    case CapaPurchaseOrderStatus.RejectOrderByPartner:
      return '발주 거절 사유';
    default:
      return '사유';
  }
};

const RequestedWithReason = (props: ProgressStoppedProps) => {
  const { purchaseOrderStatus, cancelReason = '' } = props;

  return (
    <VStack gap={16}>
      <Paid {...props} />
      <ProgressInfoReason
        reasonTitle={orderStatusToTitle(purchaseOrderStatus)}
        reasonDescription={cancelReason}
      />
    </VStack>
  );
};

export default RequestedWithReason;
